import styled from '@emotion/styled';
import red from './Palettes/red';

export const BadgeWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const UpdateBadge = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 8px;
  background-color: ${red[500]};
  border-radius: 50%;
`;
